import type { FC } from 'react'

export const GooglePlay: FC<IconProps> = () => (
  <svg
    width="136"
    height="40"
    viewBox="0 0 136 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4157_15376)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130.626 40H5.026C2.25596 40 0 37.7456 0 35V5C0 2.24439 2.25596 0 5.026 0H130.626C133.394 0 135.652 2.24439 135.652 5V35C135.652 37.7456 133.394 40 130.626 40Z"
        fill="#292929"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130.626 0.800499C132.95 0.800499 134.851 2.68828 134.851 5V35C134.851 37.3117 132.962 39.1995 130.626 39.1995H5.026C2.70266 39.1995 0.801066 37.3117 0.801066 35V5C0.801066 2.68828 2.69018 0.800499 5.026 0.800499C5.026 0.800499 130.626 0.800499 130.626 0.800499ZM130.626 0H5.026C2.25596 0 0 2.25436 0 5V35C0 37.7556 2.25596 40 5.026 40H130.626C133.394 40 135.652 37.7556 135.652 35V5C135.652 2.25436 133.394 0 130.626 0Z"
        fill="#A6A6A6"
      />
      <path
        d="M71.4616 13.232C70.5557 13.232 69.7921 12.9153 69.1882 12.2918C68.5892 11.6858 68.2548 10.8504 68.2698 9.99755C68.2698 9.08732 68.5793 8.31675 69.1882 7.70578C69.7896 7.08233 70.5532 6.76562 71.4591 6.76562C72.355 6.76562 73.1186 7.08233 73.7325 7.70578C74.3414 8.3367 74.6509 9.10727 74.6509 9.99755C74.6409 10.9103 74.3315 11.6808 73.7325 12.2893C73.1311 12.9177 72.3675 13.232 71.4616 13.232ZM44.5074 13.232C43.6215 13.232 42.8529 12.9202 42.224 12.3043C41.6001 11.6908 41.2832 10.9153 41.2832 10C41.2832 9.08483 41.6001 8.30927 42.224 7.6958C42.8404 7.07984 43.609 6.76812 44.5074 6.76812C44.9466 6.76812 45.3734 6.8554 45.7826 7.03246C46.1844 7.20453 46.5113 7.43894 46.7534 7.72572L46.8133 7.79804L46.137 8.46139L46.0671 8.37909C45.6853 7.92523 45.1737 7.70328 44.4974 7.70328C43.8935 7.70328 43.367 7.91775 42.9327 8.34169C42.496 8.76812 42.2739 9.32672 42.2739 10.0025C42.2739 10.6783 42.496 11.2369 42.9327 11.6634C43.367 12.0873 43.8935 12.3018 44.4974 12.3018C45.1413 12.3018 45.6828 12.0873 46.1046 11.6634C46.3541 11.414 46.5088 11.0649 46.5637 10.6235H44.3951V9.69081H47.4946L47.507 9.7756C47.5295 9.93271 47.552 10.0948 47.552 10.2444C47.552 11.1048 47.2924 11.8005 46.7784 12.3143C46.1944 12.9227 45.4308 13.232 44.5074 13.232ZM80.3457 13.0998H79.3899L76.4626 8.41899L76.4876 9.26188V13.0973H75.5318V6.90029H76.6223L76.6523 6.94767L79.4049 11.3566L79.3799 10.5162V6.90029H80.3457V13.0998V13.0998ZM64.2795 13.0998H63.3112V7.83296H61.6317V6.90029H65.9565V7.83296H64.277V13.0998H64.2795ZM60.8431 13.0998H59.8774V6.90029H60.8431V13.0998ZM55.4154 13.0998H54.4496V7.83296H52.7701V6.90029H57.0949V7.83296H55.4154V13.0998ZM52.1587 13.0898H48.4553V6.90029H52.1587V7.83296H49.4236V9.53371H51.8917V10.4564H49.4236V12.1571H52.1587V13.0898ZM69.8969 11.6509C70.3286 12.0823 70.8527 12.2993 71.4616 12.2993C72.088 12.2993 72.5996 12.0873 73.0263 11.6509C73.4505 11.227 73.6651 10.6709 73.6651 10C73.6651 9.32922 73.4505 8.77061 73.0288 8.34917C72.5971 7.91774 72.0705 7.70079 71.4641 7.70079C70.8377 7.70079 70.3261 7.91276 69.9019 8.34917C69.4777 8.77311 69.263 9.32922 69.263 10C69.263 10.6709 69.4752 11.2295 69.8969 11.6509Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.1803 21.7557C65.822 21.7557 63.9104 23.5437 63.9104 26.01C63.9104 28.4539 65.8345 30.2644 68.1803 30.2644C70.5386 30.2644 72.4501 28.4639 72.4501 26.01C72.4501 23.5437 70.5386 21.7557 68.1803 21.7557ZM68.1803 28.5786C66.8901 28.5786 65.7796 27.5113 65.7796 26.0001C65.7796 24.4664 66.8926 23.4215 68.1803 23.4215C69.4705 23.4215 70.581 24.4664 70.581 26.0001C70.5835 27.5212 69.4705 28.5786 68.1803 28.5786ZM58.8645 21.7557C56.5062 21.7557 54.5946 23.5437 54.5946 26.01C54.5946 28.4539 56.5186 30.2644 58.8645 30.2644C61.2227 30.2644 63.1343 28.4639 63.1343 26.01C63.1343 23.5437 61.2202 21.7557 58.8645 21.7557ZM58.8645 28.5786C57.5743 28.5786 56.4637 27.5113 56.4637 26.0001C56.4637 24.4664 57.5768 23.4215 58.8645 23.4215C60.1546 23.4215 61.2652 24.4664 61.2652 26.0001C61.2652 27.5212 60.1546 28.5786 58.8645 28.5786ZM47.7793 23.0549V24.8554H52.104C51.9718 25.8654 51.6374 26.611 51.1258 27.1222C50.4919 27.7557 49.5137 28.4439 47.7893 28.4439C45.1315 28.4439 43.0527 26.2993 43.0527 23.6434C43.0527 20.9876 45.1315 18.8429 47.7893 18.8429C49.2242 18.8429 50.2698 19.409 51.0459 20.1322L52.3237 18.8554C51.2456 17.823 49.8107 17.0325 47.7993 17.0325C44.1533 17.0325 41.0938 20.0001 41.0938 23.6335C41.0938 27.2769 44.1508 30.2345 47.7993 30.2345C49.7682 30.2345 51.2456 29.5911 52.4135 28.3791C53.6039 27.1896 53.9807 25.5113 53.9807 24.1572C53.9807 23.7357 53.9483 23.3567 53.8809 23.035H47.7768C47.7793 23.0325 47.7793 23.0549 47.7793 23.0549ZM93.1206 24.4564C92.7638 23.5013 91.6857 21.7457 89.4747 21.7457C87.2836 21.7457 85.4619 23.4689 85.4619 26.0001C85.4619 28.3891 87.2636 30.2544 89.6868 30.2544C91.6333 30.2544 92.7663 29.0649 93.2329 28.3666L91.788 27.3991C91.3089 28.1098 90.6426 28.5761 89.6968 28.5761C88.741 28.5761 88.0722 28.1422 87.628 27.2868L93.3203 24.9302C93.3203 24.9327 93.1206 24.4564 93.1206 24.4564ZM87.316 25.8779C87.2711 24.2345 88.5937 23.3991 89.5396 23.3991C90.2857 23.3991 90.9071 23.7656 91.1192 24.2993L87.316 25.8779ZM82.6918 30.0001H84.561V17.5013H82.6918V30.0001ZM79.6223 22.7008H79.5549C79.1332 22.1996 78.3321 21.7457 77.3089 21.7457C75.1852 21.7457 73.2287 23.6135 73.2287 26.0125C73.2287 28.4015 75.1753 30.2469 77.3089 30.2469C78.3196 30.2469 79.1332 29.7906 79.5549 29.2794H79.6223V29.8903C79.6223 31.5138 78.7539 32.3891 77.3539 32.3891C76.2084 32.3891 75.4972 31.5661 75.2077 30.8779L73.5831 31.5562C74.0498 32.6784 75.295 34.0674 77.3514 34.0674C79.5424 34.0674 81.3991 32.7781 81.3991 29.6335V22.0001H79.6323V22.7008C79.6348 22.7008 79.6223 22.7008 79.6223 22.7008ZM77.4761 28.5786C76.186 28.5786 75.1079 27.5013 75.1079 26.0125C75.1079 24.5113 76.186 23.424 77.4761 23.424C78.7539 23.424 79.7446 24.5237 79.7446 26.0125C79.7571 27.5013 78.7564 28.5786 77.4761 28.5786ZM101.872 17.5013H97.403V30.0001H99.2721V25.2669H101.875C103.944 25.2669 105.978 23.7681 105.978 21.3891C105.978 19.01 103.951 17.5013 101.872 17.5013ZM101.927 23.5212H99.2696V19.232H101.927C103.327 19.232 104.118 20.3866 104.118 21.3766C104.118 22.3567 103.317 23.5212 101.927 23.5212ZM113.469 21.7332C112.112 21.7332 110.712 22.3342 110.133 23.6434L111.79 24.3317C112.147 23.6434 112.8 23.409 113.492 23.409C114.46 23.409 115.438 23.9876 115.461 25.02V25.1522C115.126 24.9626 114.393 24.6734 113.514 24.6734C111.725 24.6734 109.911 25.6509 109.911 27.4838C109.911 29.1621 111.378 30.2395 113.013 30.2395C114.268 30.2395 114.959 29.6734 115.391 29.0175H115.458V29.9851H117.26V25.1971C117.26 22.9676 115.603 21.7332 113.469 21.7332ZM113.235 28.5786C112.623 28.5786 111.767 28.2794 111.767 27.5113C111.767 26.5437 112.835 26.1771 113.746 26.1771C114.57 26.1771 114.959 26.3542 115.448 26.5986C115.313 27.7207 114.365 28.5686 113.235 28.5786ZM123.833 22.0001L121.687 27.4215H121.62L119.396 22.0001H117.385L120.721 29.5786L118.82 33.7906H120.766L125.899 22.0001H123.833ZM107.008 30.0001H108.877V17.5013H107.008V30.0001Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4411 7.53364C10.1516 7.84536 9.98438 8.32167 9.98438 8.94511V31.0573C9.98438 31.6808 10.1516 32.1571 10.451 32.4563L10.5284 32.5237L22.9262 20.1346V19.8578L10.5184 7.46631L10.4411 7.53364Z"
        fill="url(#paint0_linear_4157_15376)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.0511 24.2768L22.916 20.1446V19.8553L27.0511 15.7231L27.1409 15.778L32.0322 18.5561C33.4322 19.3441 33.4322 20.6458 32.0322 21.4438L27.1409 24.2219L27.0511 24.2768Z"
        fill="url(#paint1_linear_4157_15376)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.1415 24.2219L22.9166 20L10.4414 32.4663C10.8981 32.9551 11.6642 33.01 12.5202 32.5337L27.1415 24.2219Z"
        fill="url(#paint2_linear_4157_15376)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.1415 15.7779L12.5202 7.47869C11.6642 6.98992 10.8956 7.05725 10.4414 7.54603L22.9166 19.9999L27.1415 15.7779Z"
        fill="url(#paint3_linear_4157_15376)"
      />
      <path
        opacity="0.2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.0515 24.1321L12.53 32.3765C11.7189 32.8428 10.9952 32.8104 10.5285 32.3865L10.4512 32.4638L10.5285 32.5311C10.9952 32.9526 11.7189 32.9875 12.53 32.5211L27.1513 24.2219L27.0515 24.1321Z"
        fill="black"
      />
      <path
        opacity="0.12"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.0326 21.2993L27.0391 24.1322L27.1289 24.2219L32.0201 21.4439C32.7214 21.0449 33.0658 20.5212 33.0658 20C33.0233 20.4788 32.6665 20.9327 32.0326 21.2993Z"
        fill="black"
      />
      <path
        opacity="0.25"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5198 7.62354L32.0324 18.7009C32.6663 19.0575 33.0232 19.5238 33.0781 20.0001C33.0781 19.4789 32.7337 18.9552 32.0324 18.5562L12.5198 7.4789C11.1198 6.6784 9.98438 7.34673 9.98438 8.94524V9.08987C9.98438 7.48888 11.1198 6.83301 12.5198 7.62354Z"
        fill="#2134DF"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4157_15376"
        x1="21.8142"
        y1="8.70654"
        x2="1.95686"
        y2="14.0013"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset="0.00657" stopColor="#00A1FF" />
        <stop offset="0.2601" stopColor="#00BEFF" />
        <stop offset="0.5122" stopColor="#00D2FF" />
        <stop offset="0.7604" stopColor="#00DFFF" />
        <stop offset="1" stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_4157_15376"
        x1="33.8579"
        y1="20"
        x2="9.64393"
        y2="20"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset="0.4087" stopColor="#FFBD00" />
        <stop offset="0.7754" stopColor="#FFA500" />
        <stop offset="1" stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_4157_15376"
        x1="24.8442"
        y1="22.2973"
        x2="8.91802"
        y2="49.1213"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset="1" stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_4157_15376"
        x1="7.30002"
        y1="0.178683"
        x2="14.4053"
        y2="12.1587"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset="0.0685" stopColor="#2DA771" />
        <stop offset="0.4762" stopColor="#15CF74" />
        <stop offset="0.8009" stopColor="#06E775" />
        <stop offset="1" stopColor="#00F076" />
      </linearGradient>
      <clipPath id="clip0_4157_15376">
        <rect width="135.652" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
